export default __webpack_public_path__ + "static/media/cloud9.18a87e6a.svg";